import {connect} from 'react-redux';
import React, {Component, PropTypes} from 'react';
import Subscribe from '../../components/partial/Subscribe/Subscribe';
import {subscribeUser, subscribedComplete, subscribedFail} from './../../actions';
import utils from '../../utils/utils';

class SubscribeController extends Component {

  render() {
    return (
      <Subscribe {...this.props}/>
    );
  }

  componentDidMount() {
    if (!this.props.logged) {
      utils.redirectToLogin('subscribe');
      return;
    }

    const params = {
      baseURL: window.basePath
    };
    this.props.subscribeUser(params).then(action => {
      if (!action.data.logged) {
        this.props.subscribedFail({subscribed: 'failure', progress: 'failure'});
      } else {
        this.props.subscribedComplete({subscribed: 'success', progress: 'success'});
      }
    });
  }
}

SubscribeController.propTypes = {
  subscribeUser: PropTypes.func.isRequired,
  logged: PropTypes.bool.isRequired,
  subscribedComplete: PropTypes.func.isRequired,
  subscribedFail: PropTypes.func.isRequired
};

function mapStateToProps(state) {
  return {
    subscribed: state.subscribe.subscribed,
    logged: state.user.logged
  };
}
function mapDispatchToProps(dispatch) {
  return {
    subscribeUser: params => dispatch(subscribeUser(params)),
    subscribedComplete: params => dispatch(subscribedComplete(params)),
    subscribedFail: params => dispatch(subscribedFail(params))
  };
}
export default connect(mapStateToProps, mapDispatchToProps)(SubscribeController);



// WEBPACK FOOTER //
// ./containers/Subscribe/Subscribe.js